/**
 *@author shaolei
 *@date 2020/04/03
 *@file_name:help
 *@Description:帮助页面
 */
<template>
  <div class="help">
    <v-header></v-header>
    <div class="emptyheader"></div>
    <div class="container clearfix">
      <div class="container-menu">
        <el-menu
          :default-active="activeIndex"
          class="el-left-menu"
          background-color="#fff"
          text-color="#333"
        >
          <el-menu-item @click="toLink('/help/baseProblems')" index="/help/baseProblems">
            <template slot="title">
              <img class="icon-menu" src="@/assets/images/icon-common.png" alt="">
              <span slot="title">常见问题</span>
            </template>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="container-main">
       <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import Vheader from "@/layout/components/header";
export default {
  data() {
    return {
      activeIndex:"/help/baseProblems",
    };
  },
  created() {
   
  },
  mounted() {},
  methods:{
    /** 页面跳转 */
    toLink(path,params){
      this.isIntrodu = true
      if(params){
        this.$router.push({
          path:path,
          query:{
            name:params.name,
            id:params.id
          }
        })
      }else{
        this.$router.push(path)
      }
    },
  },
  components: {
    "v-header": Vheader
  },
  computed: {

  },
};
</script>
<style lang="less" scoped>
.help {
  min-height: 100vh;
  margin: 0 auto;
  background: #f7f6f5;
  box-sizing: border-box;

  .container {
    margin-top: 20px;

    .container-menu {
      float: left;
      width: 256px;
      padding: 20px 0;
      min-height: 870px;
      background: #fff;
      border-radius: 8px 0 0 8px;

      .el-left-menu {
        border-right: none;
        font-size: 14px;

        .icon-menu {
          width: 16px;
          height: 16px;
          margin-right: 10px;
          vertical-align: middle;
        }

        /deep/.el-submenu {
          /deep/.el-submenu__title {
            height: 60px;
            line-height: 60px;
          }
        }

        >.el-menu-item {
          height: 60px;
          line-height: 60px;
        }

        >.is-active {
          color: #333333;
          font-weight: 500;
          position: relative;

          &::after{
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            height: 60px;
            width: 10px;
            background: #FABE00;
          }

          /deep/.el-submenu__title {
            span {
              font-weight: 500;
            }
          }
        }

        /deep/.el-menu {
          /deep/.el-menu-item-group {
            background-color: #fafafa;

            /deep/ul {
              background-color: #fafafa !important;

              /deep/li {
                background-color: #fafafa !important;
                font-size: 12px;
                padding-left: 50px !important;
                color: #666666 !important;
                font-weight: 400;
              }

              /deep/.is-active {
                color: #fabe03 !important;
                position: relative;

                &::after {
                  content: "";
                  position: absolute;
                  width: 7px;
                  height: 7px;
                  background: #fabe03;
                  left: 30px;
                  top: 22px;
                  border-radius: 100%;
                }
              }
            }
          }
        }
      }
    }
    .container-main {
      float: right;
      width: calc(100% - 276px);
      min-height: calc(100vh - 180px);
      background: #fff;
      padding: 0 20px;
      box-sizing: border-box;
    }
  }
}
</style>